/**
 * What this portal serves.
 *
 * The portal at this domain is the Strix Gov RCM operator portal: sign in, the Recovery screen and
 * the public proof pages. The admissions, shadow-run, connector and agent pages were removed on
 * 2026-09-30; their server procedures and the CLI remain.
 *
 * The earlier clinical portal (landing page, sign-up, patient, provider, utilization management,
 * and the old admin dashboard, governance dashboard and console) is PARKED, not deleted: its code
 * stays in the tree, but no route, nav entry or sign-in role reaches it unless the build sets
 * `VITE_LEGACY_PORTAL_ENABLED=true`. The value is read at build time, so a deployment cannot turn
 * the old pages on without a rebuild. Its server routes are unchanged.
 */
export const LEGACY_PORTAL_ENABLED = import.meta.env.VITE_LEGACY_PORTAL_ENABLED === 'true';

/** The Recovery screen: where an operator lands after signing in. */
export const RECOVERY_PATH = '/admin/recovery';

export function isOperatorRole(role: string | undefined): boolean {
  return role === 'admin' || role === 'super_admin';
}

/** Where a signed-in person with this role goes when they arrive at the portal. */
export function homePathForRole(role: string | undefined, legacy: boolean = LEGACY_PORTAL_ENABLED): string {
  if (isOperatorRole(role)) return legacy ? '/admin' : RECOVERY_PATH;
  if (!legacy) return '/not-available';
  return role === 'provider' ? '/provider' : '/dashboard';
}
